// Phase 1A Phase 9C.2 — Domain icon definitions.
//
// 10 domain glyphs. Geometric, symbolic, never literal logos.
// Football = pitch + ball. Crypto = chain links (no Bitcoin mark).
// Forex = crossed wave-arrows (no $/€/£ glyphs). Etc.

import type { IconDef } from "./icon-types.ts";

export const DOMAIN_ICONS: Record<string, IconDef> = {
  "domain.football": {
    key: "domain.football",
    shapes: [
      { type: "rect", x: 4, y: 6, width: 16, height: 12, rx: 1 },
      { type: "line", x1: 12, y1: 6, x2: 12, y2: 18 },
      { type: "circle", cx: 12, cy: 12, r: 2.2 },
    ],
  },
  "domain.rollover": {
    key: "domain.rollover",
    shapes: [
      { type: "path", d: "M5 12 A7 7 0 1 1 17 17" },
      { type: "polyline", points: "14,17 17,17 17,14" },
    ],
  },
  "domain.powerball": {
    key: "domain.powerball",
    shapes: [
      { type: "path", d: "M6 4 H18 V20 H6 Z" },
      { type: "path", d: "M11 7 L9 13 H13 L11 17", strokeWidth: 2 },
    ],
  },
  "domain.owl_hour": {
    key: "domain.owl_hour",
    shapes: [
      { type: "path", d: "M17 5 A8 8 0 1 0 17 19 A6 6 0 1 1 17 5 Z" },
      { type: "circle", cx: 13, cy: 12, r: 1.4 },
    ],
  },
  "domain.crypto": {
    key: "domain.crypto",
    shapes: [
      { type: "path", d: "M9 7 A4 4 0 0 1 13 11 A4 4 0 0 1 9 15 A4 4 0 0 1 5 11" },
      { type: "path", d: "M15 9 A4 4 0 0 1 19 13 A4 4 0 0 1 15 17 A4 4 0 0 1 11 13" },
    ],
  },
  "domain.forex": {
    key: "domain.forex",
    shapes: [
      { type: "path", d: "M4 9 Q8 5 12 9 T20 9" },
      { type: "polyline", points: "17,7 20,9 17,11" },
      { type: "path", d: "M20 15 Q16 19 12 15 T4 15" },
      { type: "polyline", points: "7,17 4,15 7,13" },
    ],
  },
  "domain.polymarket": {
    key: "domain.polymarket",
    shapes: [
      { type: "line", x1: 12, y1: 5, x2: 12, y2: 19 },
      { type: "line", x1: 6, y1: 9, x2: 18, y2: 9 },
      { type: "path", d: "M4 13 L6 9 L8 13 Z" },
      { type: "path", d: "M16 13 L18 9 L20 13 Z" },
    ],
  },
  "domain.stocks": {
    key: "domain.stocks",
    shapes: [
      { type: "rect", x: 6, y: 10, width: 2.5, height: 8 },
      { type: "line", x1: 7.25, y1: 7, x2: 7.25, y2: 19 },
      { type: "rect", x: 11, y: 6, width: 2.5, height: 10 },
      { type: "line", x1: 12.25, y1: 4, x2: 12.25, y2: 17 },
      { type: "rect", x: 16, y: 11, width: 2.5, height: 6 },
      { type: "line", x1: 17.25, y1: 8, x2: 17.25, y2: 19 },
    ],
  },
  "domain.academy": {
    key: "domain.academy",
    shapes: [
      {
        type: "path",
        d: "M12 7 C10 6 6 6 4 7 V18 C6 17 10 17 12 18 C14 17 18 17 20 18 V7 C18 6 14 6 12 7 Z",
      },
      { type: "line", x1: 12, y1: 7, x2: 12, y2: 18 },
    ],
  },
  "domain.admin": {
    key: "domain.admin",
    shapes: [
      { type: "path", d: "M4 16 A8 8 0 0 1 20 16" },
      { type: "line", x1: 12, y1: 16, x2: 16, y2: 9 },
      { type: "circle", cx: 12, cy: 16, r: 1.2, filled: true },
    ],
  },
};
